import { useSrStatusText } from '@/src/hooks/store/useSrStatusText';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './JamSpinner.module.scss';

const JamSpinner: React.FC = () => {
  const { t } = useTranslation();
  const { setStatusText } = useSrStatusText();

  useEffect(() => {
    setStatusText(t(i18nKeys.general.loading));

    return () => setStatusText('');
  }, []);

  return (
    <div className={styles.backdrop} aria-live="assertive">
      <div className="jam-spinner">
        <div className="loading">
          <img src="/assets/spinner-image.png" alt={t(i18nKeys.general.loading)} />
          <div className={styles.srOnly}>{t(i18nKeys.general.loading)}</div>
        </div>
      </div>
    </div>
  );
};

export default JamSpinner;
